import React,{ Component } from 'react'
import LeftSidebar from '../../LeftSidebar/LeftSidebar'
import RightSidebar from '../../RightSidebar/RightSidebar'
import HomeMainbar from '../../HomeMainbar/HomeMainbar'
import "../../../App.css"

export class Home extends Component {

  componentDidMount() {
    (function(d, m){
        var kommunicateSettings = 
            {"appId":"2c9ac41341aeec520614f04af4da85879","popupWidget":true,"automaticChatOpenOnNavigation":true};
        var s = document.createElement("script"); s.type = "text/javascript"; s.async = true;
        s.src = "https://widget.kommunicate.io/v2/kommunicate.app";
        var h = document.getElementsByTagName("head")[0]; h.appendChild(s);
        window.kommunicate = m; m._globals = kommunicateSettings;
    })(document, window.kommunicate || {});
  }
  
  render() {
    return (
      <div className='home-container-1'>
          <LeftSidebar />
          
          <div className='home-container-2'>
            <HomeMainbar />
            <RightSidebar />
          </div>
      </div>
    )
  }
}

export default Home